import { render, staticRenderFns } from "./TechnicalSupport.vue?vue&type=template&id=51b4cdbe"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports